import "./Gallery.scss";
import { define } from "@shared/Lib/registry";
import type { Component } from "@shared/Lib/types";

export class Gallery implements Component {
  readonly el: HTMLElement;

  constructor(el: HTMLElement) {
    this.el = el;
    this.init();
  }

  private init(): void {}

  destroy(): void {}
}

define("Gallery", (el) => new Gallery(el));
